<template>
    <div>
        <PCProduct 
            v-if=" getInfor === true && isMobile === false" 
            :json="json" 
        />
        <MobProduct 
            v-if=" getInfor === true && isMobile === true" 
            :json="json" 
        />
    </div>
</template>
<script>

import PCProduct from '@/components/pc/PCProduct'
import MobProduct from '@/components/mobile/MobProduct'

// import jquery from 'jquery'

import productJson from '@/json/product'

import '@/assets/less/module/module-base-list-ulmoudle2_product-list-ul.less'

export default {
    name: 'Product',
    props: {
        isMobile: Boolean
    },
    components: {
        PCProduct,
        MobProduct
    },
    data: function(){
        return {
            json: productJson,
            getInfor: true
        }
    },
    mounted() {
        // let _this = this;
        // window.getAjaxJson = '';
        // jquery.get('./json/product.js', function(){
        //    _this.json =  window.getAjaxJson
        //    _this.getInfor = true;
        // });
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>